import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { __TOPONYMY_API_URL__ } from 'shell/constants/environment';
import { ItemVM } from 'shell/view-models/item';
import { HttpResponseList } from 'shell/models/http-response';
import { CirculationAreaType } from 'shell/models/circulation-area-type';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';

interface DeliberatedTypeProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  required?: boolean;
  label?: string;
}

const DeliberatedTypeComponent = ({
  disabled,
  onChange,
  value,
  error,
  required,
  label = 'Tipo Delibera',
}: DeliberatedTypeProps): React.ReactElement => {
  const [typeDeliberated] = useHttpFetch<HttpResponseList<CirculationAreaType>, Array<ItemVM>>(
    `${__TOPONYMY_API_URL__}/areaCircolazione/tipo/delibera`,
    {
      options: {
        method: 'GET',
        errorCatching: true,
        loading: true,
      },
      onBootstrap: true,
      transformer: (response) => {
        return response.data.payload.list?.map((item) => ({
          id: item.key,
          value: item.descrizione,
        }));
      },
    }
  );

  const types: Array<ItemVM> = (typeDeliberated.data as Array<ItemVM>) || [];

  return (
    <PmiFormControl fullWidth error={error}>
      <InputLabel id="type-deliberated-label" disabled={disabled}>
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId="type-deliberated-label"
        id="typeDeliberated"
        name="typeDeliberated"
        value={value}
        label={required ? `${label} *` : label}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        {types.map((type: ItemVM) => (
          <MenuItem key={type.id} value={type.id}>
            {type.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

DeliberatedTypeComponent.displayName = 'Deliberated type component';

const DeliberatedType = memo(DeliberatedTypeComponent);

export default DeliberatedType as typeof DeliberatedTypeComponent;
